import React, { useState, useEffect } from 'react'

import { Dialog, IconButton, DialogTitle, DialogContent, Button } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import './style.css'
import { DialogNewUnidad } from './DialogNewUnidad'
import { Model } from '../../../models/model'

export const DialogUnidadNegocio = ({ open, setOpen }) => {

    // const { unitList } = useSelector(state => state.general)
    const [openNewUnidad, setOpenNewUnidad] = useState(false)
    const [unidadList, setUnidadList] = useState([])

    // const [filters, setFilters] = useState({
    //     check_venta: false,
    //     check_compra: false
    // })

    const [initialData, setInitialData] = useState({
        id: 0,
        nombre: '',
        estado: true,
        por_defecto: false
    })

    useEffect(() => {
        getAllUnit()
    }, [])

    const getAllUnit = async () => {

        const resultAllUnit = await Model.getAll({
            url: `unidad`,
        })

        setUnidadList(resultAllUnit)

    }

    // const handleChangeChecked = ({ target }) => {
    //     setFilters({
    //         ...filters,
    //         [target.name]: target.checked,
    //     })
    // }

    const openEdit = (item) => {

        setInitialData({
            id: item.id,
            nombre: item.nombre,
            estado: item.estado,
            por_defecto: item.por_defecto
        })

        setOpenNewUnidad(true)

    }

    const handleDelete = async (item) => {
        const statusDelete = await Model.delete({
            url: `unidad/${item.id}`,
        })

        if (statusDelete) {
            getAllUnit()
        }
    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                Unidades de negocio
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <div className="table-responsive">

                    <div className='m-2'>
                        {unidadList.length === 0 && <h3 style={{ fontSize: '14px' }}>Aún no existe unidades agregadas</h3>}
                        <Button
                            className='p-btn-primary'
                            variant="contained"
                            size="small"
                            type='button'
                            onClick={() => setOpenNewUnidad(true)}
                        >
                            + Agregar
                        </Button>
                    </div>

                    {unidadList.length > 0 &&
                        <table className="table p-table-global">
                            <thead className='p-thead-global'>
                                <tr className="text-center p-tr-titles-global">
                                    <th className='text-start'>Unidad de negocio</th>
                                    <th className='text-center'>Habilitado</th>
                                    {/* <th className='text-center'>Por defecto</th> */}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {unidadList?.map(item => (
                                    <tr key={item.id} className='p-tr-body-global'>
                                        <td className="text-start" style={{ textTransform: 'uppercase' }}>
                                            {item.nombre || '---'}
                                        </td>
                                        <td className="text-center" style={{ textTransform: 'none' }}>
                                            {item.estado ?
                                                <i
                                                    className="bi bi-check-circle"
                                                    style={{ color: '#8E24AA', fontSize: '14px' }}
                                                ></i>
                                                :
                                                <i
                                                    className="bi bi-x-circle"
                                                    style={{ fontSize: '14px' }}
                                                ></i>
                                            }
                                        </td>
                                        {/* <td className="text-center" style={{ textTransform: 'none' }}>
                                            {item.por_defecto &&
                                                <i
                                                    className="bi bi-check-circle"
                                                    style={{ color: '#8E24AA', fontSize: '14px' }}
                                                ></i>
                                            }
                                        </td> */}
                                        <td className="text-center">
                                            <i className="bi bi-pencil" style={{ cursor: 'pointer' }} onClick={() => openEdit(item)}></i>
                                            <i className="bi bi-trash ms-3" style={{ cursor: 'pointer' }} onClick={() => handleDelete(item)}></i>
                                        </td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    }

                </div>
            </DialogContent>

            {openNewUnidad &&
                <DialogNewUnidad
                    open={openNewUnidad}
                    setOpen={setOpenNewUnidad}
                    initialData={initialData}
                    getAllUnit={getAllUnit}
                />
            }

        </Dialog>
    )
}